import cfiLogic from '../../cfiLogic';

/**
 * Returns the pixel offset from the top of a frame where a CFI begins.
 *
 * @method getPixelsForCfi
 * @param {Element} frame
 * @param {String} cfi
 * @returns {Number}
 */
const getPixelsForCfi = (frame, cfi) => {
  const range = cfiLogic.getRangeForCfi(frame.contentDocument, cfi);

  switch (range.startContainer.nodeType) {
    case Node.TEXT_NODE:
      // if it is just text, get the top of the text selection
      return range.getClientRects()[0].top;
    case Node.DOCUMENT_NODE:
      // if it is the document itself, count this as being at the top
      return 0;
    default:
      // if it spans multiple elements, return the top of the first element
      return range.startContainer.getBoundingClientRect().top;
  }
};

export default getPixelsForCfi;
